/* eslint-disable @typescript-eslint/no-var-requires */
const defaultsDeep = require('../utils/defaultsDeepCommonJS');

const defaults = require('./defaults');
const overrides = require('./overrides');

module.exports = defaultsDeep(overrides, defaults);
